module.exports = __webpack_public_path__ + "static/friedberger_allgemeine_logo-ce79d98bd2bcf27a28f86adf6ecef981.webp";